<template lang="pug">
.d-flex.align-center.gap-16
  dv-btn(
    :to="{ name: 'login' }"
  )
    v-icon.mr-2(:size="20") $ui-user-plus
    p Авторизация
</template>

<script>
import DvBtn from '@/packages/ui/components/buttons/DvBtn.vue';

export default {
  components: {
    DvBtn,
  },
  props: {},
  computed: {},
};
</script>
